import Projects from '@/components/projects/Projects'
import CreateCompany from '@/components/projects/CreateCompany'
import CreateProperty from '@/components/projects/CreateProperty'

import Exits from '@/components/Investment/Exit'
import CreateExit from '@/components/Investment/CreateExit'

import Enum from '@/shared/enum'

import Investments from '@/components/Investment/Investment'

let projectsRoutes = [
  {
    meta: {
      title: 'menu.projects',
      ico: 'building',
      permission: ['Pages.Projects'],
    },
    path: '/projects',
    component: {template: '<router-view/>'},
    children: [
      {
        name: 'projects',
        path: '',
        component: Projects,
        meta: {permission: ['Pages.Projects']},
      },
      {
        name: 'projects_company_create',
        path: 'company/create',
        props: {compMode: Enum.Mode.CREATE},
        meta: {permission: ['Pages.Projects.Company.Create']},
        component: CreateCompany,
      },
      {
        name: 'projects_property_create',
        path: 'property/create',
        props: {compMode: Enum.Mode.CREATE},
        meta: {permission: ['Pages.Projects.Property.Create']},
        component: CreateProperty,
      },
      {
        name: 'projects_company_edit',
        path: 'company/edit/:id',
        props: {compMode: Enum.Mode.UPDATE},
        meta: {permission: ['Pages.Projects.Company.Create']},
        component: CreateCompany,
      },
      {
        name: 'projects_property_edit',
        path: 'property/edit/:id',
        props: {compMode: Enum.Mode.UPDATE},
        meta: {permission: ['Pages.Projects.Property.Create']},
        component: CreateProperty,
      },
      {
        name: 'projects_company_view',
        path: 'company/view/:id',
        props: {compMode: Enum.Mode.READ},
        meta: {permission: ['Pages.Projects.Company.View']},
        component: CreateCompany,
      },
      {
        name: 'projects_property_view',
        path: 'property/view/:id',
        props: {compMode: Enum.Mode.READ},
        meta: {permission: ['Pages.Projects.Property.View']},

        component: CreateProperty,
      },
      {
        name: 'projects_company_copy',
        path: 'company/copy/:id',
        props: {compMode: Enum.Mode.COPY},
        meta: {permission: ['Pages.Projects.Create']},
        component: CreateCompany,
      },
      {
        name: 'projects_property_copy',
        path: 'property/copy/:id',
        meta: {permission: ['Pages.Projects.Create']},
        props: {compMode: Enum.Mode.COPY},
        component: CreateProperty,
      },
    ],
  },
]

export default projectsRoutes



// WEBPACK FOOTER //
// ./src/router/projects.js